import { MenuActionItem } from "src/components/menu-actions";
import { UserTransaction } from "../types/user-transaction.entity";

type GetUserTransactionActionsProps = {
  transaction: UserTransaction;
  showUserAction?: boolean;
  refundTransaction: (t: UserTransaction) => void;
};

export const checkIsTransactionRefundable = (transaction: UserTransaction) => {
  // For AI sessions, check if it's a debit transaction with positive amount
  if (transaction.eventCategory === "AI_INTERACTION") {
    return (
      transaction.type === "DEBIT" &&
      transaction.status === "FINALIZED" &&
      transaction.amount > 0
    );
  }
  
  // For other transaction types, use the existing logic
  return (
    transaction.label !== "ADMIN_SESSION_DEDUCTION" &&
    transaction.type === "DEBIT" &&
    transaction.status === "FINALIZED" &&
    transaction.metadata.sessionDate &&
    transaction.metadata.sessionDate.toDate().getTime() < Date.now()
  );
};
export const getUserTransactionActions = ({
  transaction,
  showUserAction = true,
  refundTransaction,
}: GetUserTransactionActionsProps): MenuActionItem[] => {
  const actions: MenuActionItem[] = [];

  const { sessionId, bookingId } = transaction.metadata;

  if (showUserAction) {
    actions.push({
      type: "LINK",
      label: "Show User",
      to: `users/${transaction.userId}`,
    });
  }

  const sessionLink: MenuActionItem | null = sessionId
    ? {
        type: "LINK",
        label: "Show Session",
        to: `/sessions/${sessionId}`,
      }
    : null;

  const refundBtn: MenuActionItem | null = checkIsTransactionRefundable(transaction)
    ? {
        type: "BUTTON",
        label: "Refund",
        color: "primary",
        onClick: () => refundTransaction(transaction),
      }
    : null;

  switch (transaction.eventCategory) {
    case "AI_INTERACTION":
      return [
        {
          type: "LINK",
          label: "Show Session",
          to: `/ai-sessions/${sessionId}`,
        },
        ...actions,
        // Refund button removed for AI sessions - only available in AI session details page
      ];

    case "BOOKING_MEETING":
      return [
        {
          type: "LINK",
          label: "Show Booking",
          to: `/bookings/${bookingId}`,
        },
        ...(sessionLink ? [sessionLink] : []),
        ...actions,
        ...(refundBtn ? [refundBtn] : []),
      ];

    case "DIRECT_MEETING":
    case "LOUNGE_MEETING":
    case "WITHDRAWAL":
      return [...(sessionLink ? [sessionLink] : []), ...actions, ...(refundBtn ? [refundBtn] : [])];

    default:
      return [];
  }
};
